/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {setUser} from '@sentry/browser';

import * as analytics from 'analytics/Analytics';
import licenses from 'user/Licenses';

import {BootstrapUser} from './Types';

interface UserData {
  email: string;
  id: string;
  impersonating?: boolean;
}

export function setupUser(userSummary: BootstrapUser): void {
  if (window.user != null) {
    // Already configured.
    return;
  }

  window.user = userSummary;

  licenses.reload();

  // @ts-expect-error
  if (!window.user.track || window.testing != null) {
    analytics.disable();
  }

  // Raven / Sentry
  const userData: UserData = {
    email: window.user.email,
    id: window.user.url_identifier,
  };
  if (window.impersonating) {
    userData.impersonating = true;
  }
  setUser(userData);
}
